import { defineTrpcContract, query } from "@amtana/module";

import { resolveAllInputSchema, resolveAllOutputSchema } from "./feature-flag.schemas.ts";

// Declared once. `resolveAll` is the one door the browser calls (S8.04): the active
// organization's own flags, read for itself, nothing a permission or a plan gate scopes
// (S8.02's "decide door kind" note, dev/docs/decisions.md). `isEnabled` and `setOverride`
// stay peer-only; no transport door binds them.
export const featureFlagTrpcContract = defineTrpcContract("feature-flag", {
  resolveAll: query({ input: resolveAllInputSchema, output: resolveAllOutputSchema }),
});
